var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 434,
    height: 130.611,
    viewBox: "0 0 434 130.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_168",
    x: 0,
    y: 0,
    width: 434,
    height: 130.611,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(16 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16, -6)",
    filter: "url(#Path_168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168-2",
    "data-name": "Path 168",
    d: "M409,56.269a56.626,56.626,0,0,1-16.175,39.787,54.535,54.535,0,0,1-39.047,16.482l-280.957.072a54.355,54.355,0,0,1-32.643-10.864C20.719,115.367-7,107.5-7,107.5s24.553-6.383,24.553-51.2C17.553,25.207,42.29,0,72.808,0h280.97C384.275,0,409,25.193,409,56.269",
    transform: "translate(16 6)",
    fill: "#002c69"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatInfo);
export default __webpack_public_path__ + "static/media/chat-info.451f2a4e3b44daa9c395bbdeb72b0ef4.svg";
export { ForwardRef as ReactComponent };